import PropTypes from 'prop-types';
import { useSettingsContext } from 'src/components/settings';
import DashboardFiltersLayout from './dashboard-filters-layout';

export default function DashboardPageLayout({ header, notice, children, filtersConfig }) {
  const settings = useSettingsContext();

  const isHorizontal = settings.themeLayout === 'horizontal';

  const showHeader =
    !isHorizontal ||
    (filtersConfig && filtersConfig.showHeaderOnHorizontal === true);

  const showCancelledFilter =
  filtersConfig && filtersConfig.showCancelledFilter === true;

  // Telas com filtros próprios (ex.: controle de silos) escondem a barra, mas continuam
  // dentro do mesmo provider — o estado de usina/período segue compartilhado entre telas.
  const hideFiltersBar = filtersConfig && filtersConfig.hideFiltersBar === true;

  return (
    <>
      {showHeader && header}

      {/* Aviso da tela (ex.: plano 5.0) logo abaixo do título, acima dos filtros. */}
      {notice}

      <DashboardFiltersLayout showCancelledFilter={showCancelledFilter} hideFiltersBar={hideFiltersBar}>
        {children}
      </DashboardFiltersLayout>
    </>
  );
}

DashboardPageLayout.propTypes = {
  header: PropTypes.node,
  notice: PropTypes.node,
  children: PropTypes.node,
  filtersConfig: PropTypes.object
};